import { render, staticRenderFns } from "./TableDataDownloaded.vue?vue&type=template&id=3022a85a"
import script from "./TableDataDownloaded.vue?vue&type=script&lang=js"
export * from "./TableDataDownloaded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports